import {
  Badge,
  Button,
  Col,
  Descriptions,
  Image,
  Modal,
  Row,
  Table,
  Tabs,
  Timeline,
  Typography,
  Upload,
  message
} from "antd";
import { get, isEmpty } from "lodash";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import services from "services";

import NoImagePlaceholderBlend from "../../../../../images/NoImagePlaceholderBlend.png";
import { UNIT_TYPE } from "../../_redux/constants";
import ProfileIncidentPage from "./ProfileIncidentPage";
import ProfileLogPage from "./ProfileLogPage";
import ProfileTaskPage from "./ProfileTaskPage";
import QRCode from "react-qr-code";
import { UploadOutlined } from "@ant-design/icons";

const { Text } = Typography;

const IMAGE_STYLE = {
  justifySelf: "center",
  width: "80%",
  height: "64px",
  objectFit: "cover",
  borderRadius: "0.3rem"
};

let isOver = false;

export const ProfileDevicesModal = ({ config, _handleToggleModal }) => {
  const [dataDetail, setDataDetail] = useState({});
  const [dataLog, setDataLog] = useState({
    data: [],
    total: 0
  });

  const [timelineConfig, setTimelineConfig] = useState({
    page: 0,
    size: 20
  });

  const [totalTabs, setTotalTabs] = useState({
    incident: undefined,
    task: 0
  });

  const [listFilter, setListFilter] = useState({
    task_type: []
  });

  const [dataStatistic, setDataStatistic] = useState({});
  const [fileList, setFileList] = useState([]);

  const props = {
    fileList,
    defaultFileList: fileList,
    listType: "picture",
    name: "file",
    multiple: false,
    showUploadList: false,
    beforeUpload: file => {
      setFileList([file]);
      return false;
    }
  };

  const getDetail = useCallback(async device_id => {
    let res = await services.GdmsService.getProfileDeviceById({
      device_id
    });
    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data.device_info") || {};
      setDataDetail(data);
    } else {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin profile"));
    }
  }, []);

  const getActivity = useCallback(async params => {
    let res = await services.GdmsService.getProfileActivity(params);
    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data", []);
      let total = get(res, "total_elements", 0);
      if (total <= data.length) {
        isOver = true;
      }
      setDataLog(prev => {
        return {
          ...prev,
          data,
          total
        };
      });
    } else {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin logs"));
    }
  }, []);

  const _handleScroll = async e => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    if (scrollHeight - scrollTop === clientHeight && !isOver) {
      let params = {
        page: timelineConfig.page + 1,
        size: timelineConfig.size,
        device_id: get(config?.dataSource, "device_id") || undefined
      };

      let res = await services.GdmsService.getProfileActivity(params);
      const isSuccess = get(res, "success");
      let data = [];
      if (isSuccess) {
        data = get(res, "data", []);
        let total = get(res, "total_elements", 0);
        let joinData = JSON.parse(JSON.stringify([...dataLog.data, ...data]));
        if (total <= joinData.length) {
          isOver = true;
        }
        setDataLog(prev => {
          return {
            ...prev,
            data: joinData
          };
        });
      } else {
        message.error(get(res, "message", "Có lỗi khi lấy thông tin logs"));
      }

      setTimelineConfig(prev => {
        return {
          ...prev,
          page: prev.page + 1
        };
      });
    }
  };

  const renderDetailInfo = dataDetail => {
    let properties = get(dataDetail, "properties", []);

    if (isEmpty(properties)) {
      return "Không có thông tin thiết bị";
    }

    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gridTemplateRows: "1fr",
          gridGap: "1em 0.5em"
        }}
      >
        {properties.map((item, index) => {
          return (
            <div
              key={index}
              className="d-flex flex-column justify-content-between border-right border-primary"
            >
              <b>{item.value}</b>
              <div>{item.desc}</div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderGeneralInfo = device_info => {
    const name = get(device_info, "name") || "-";
    const device_id = get(device_info, "device_id") || "-";
    const station_name = get(device_info, "station_name") || "-";
    const station_position = get(device_info, "station_position") || "-";
    const asset_code = get(device_info, "asset_code") || "-";
    const file = get(device_info, "file") || undefined;
    return (
      <Descriptions labelStyle={{ fontWeight: 500, minWidth: 100 }} column={3}>
        <Descriptions.Item label="Tên thiết bị">{name}</Descriptions.Item>
        <Descriptions.Item label="Mã thiết bị">{device_id}</Descriptions.Item>
        <Descriptions.Item label="Mã tài sản">{asset_code}</Descriptions.Item>
        <Descriptions.Item label="Kho">{station_name}</Descriptions.Item>
        <Descriptions.Item label="Vị trí">{station_position}</Descriptions.Item>
        <Descriptions.Item label="File">
          <Upload
            {...props}
            onChange={async info => {
              let file = new FormData();
              file.append("file", info.file, info.file?.name);
              const res = await services.GdmsService.uploadDeviceSpecFile(
                { device_id: get(config?.dataSource, "device_id") },
                file
              );
              if (res?.success) {
                message.success("Upload file thành công.");
                let device_id = get(config?.dataSource, "device_id");
                getDetail(device_id);
              } else {
                return message.error(
                  get(res, "message", "Upload file thất bại.")
                );
              }
            }}
          >
            <Button
              type="text"
              size="small"
              className="text-primary mr-2"
              icon={<UploadOutlined />}
            ></Button>
          </Upload>
          {file && (
            <a href={file} target="_blank" rel="noreferrer">
              Xem file
            </a>
          )}
        </Descriptions.Item>
      </Descriptions>
    );
  };

  const columns = [
    {
      title: "Ngày",
      key: "date",
      align: "center",
      dataIndex: "date",
      render: value => {
        return dayjs(value, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
    },
    {
      title: "Kho",
      key: "station_name",
      align: "center",
      dataIndex: "station_name"
    },
    {
      title: "Công việc",
      key: "task_type",
      align: "center",
      dataIndex: "task_type"
    },
    {
      title: "Loại thiết bị",
      dataIndex: "device_name",
      align: "center"
    },
    {
      title: "Vị trí",
      dataIndex: "station_position",
      align: "center"
    },
    {
      title: "Độ ưu tiên",
      dataIndex: "priority",
      align: "center",
      render: value => {
        return <span>{`Cấp ${value}`}</span>;
      }
    },
    {
      title: "Công việc",
      dataIndex: "task_name"
    },
    {
      title: "Thời gian thực hiện",
      dataIndex: "total_time_spend_second",
      align: "center",
      render: value => `${value} giây`
    },
    {
      title: "Người thực hiện",
      dataIndex: "username",
      align: "center"
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: (value, item) => {
        if ("DOING" === value) {
          return (
            <p>
              <Badge color="orange" text={value} />
            </p>
          );
        } else if ("DONE" === value) {
          return (
            <>
              <div>
                <Badge color="green" text={value} />
              </div>

              <div>
                {item["finished_time"]
                  ? dayjs(item["finished_time"]).format("DD/MM/YYYY HH:mm:ss")
                  : ""}
              </div>
            </>
          );
        } else if ("PAST_DUE" === value) {
          return (
            <p>
              <Badge color="f50" text={value} />
            </p>
          );
        }
      }
    }
  ];

  const expandedRowRender = record => {
    const columns_device = [
      {
        title: "Thành phần kiểm tra",
        dataIndex: "sub_device_alias_name",
        align: "center"
      },
      {
        title: "Chi tiết công việc",
        dataIndex: "content",
        render: text => {
          return <div style={{ whiteSpace: "pre-line" }}>{text}</div>;
        }
      },
      {
        title: "Thời gian thực hiện",
        dataIndex: "time_spend",
        align: "center",
        render: (value, item) => {
          return <span>{`${value} ${UNIT_TYPE?.[item.time_unit] || ""}`}</span>;
        }
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: value => {
          if ("FINISHED" !== value) {
            return (
              <p>
                <Badge color="#f50" text={value} />
              </p>
            );
          } else {
            return (
              <p>
                <Badge color="green" text={value} />
              </p>
            );
          }
        }
      },
      {
        title: "Ảnh/Video",
        dataIndex: "media_url",
        align: "center",
        render: value => {
          if (!value) return "";
          return value?.map((item, index) => (
            <Image
              key={index}
              style={IMAGE_STYLE}
              src={item || NoImagePlaceholderBlend}
              fallback={NoImagePlaceholderBlend}
              height={64}
              preview={item || false}
            />
          ));
        }
      }
    ];

    const sub_data = record?.maintain_subtasks || [];

    return (
      <Table
        bordered
        rowKey={"subtask_id"}
        columns={columns_device}
        dataSource={sub_data}
        pagination={false}
      />
    );
  };

  const handleShowLogDetail = data => {
    return Modal.info({
      width: "80%",
      bodyStyle: { height: "700px", overflow: "auto" },
      title: "Chi tiết",
      centered: true,
      okText: "Đóng",
      maskClosable: true,
      closable: true,
      okButtonProps: { style: { display: "none" } },
      content: (
        <Table
          bordered
          size="small"
          columns={columns}
          dataSource={[data]}
          rowKey="task_id"
          pagination={false}
          scroll={{
            x: 1200
          }}
          expandable={{
            expandedRowRender,
            defaultExpandedRowKeys: ["0"]
          }}
        />
      )
    });
  };

  const renderActivity = data => {
    return data.map((item, index) => {
      let time = item?.change_time
        ? dayjs(item.change_time).format("DD/MM/YYYY HH:mm:ss")
        : "-";
      let description = item?.description;
      let ex_task_id = item?.ex_task_id;
      let type = item?.type;
      let type_name = (listFilter?.task_type || []).find(
        item => item.value === type
      )?.name;

      return (
        <Timeline.Item key={index}>
          <span>{`${time} : `}</span>
          <span className={type === "INCIDENT" ? "text-danger" : ""}>
            {type_name ? `Loại: ${type_name}. ` : ""}
          </span>
          <span>{`Mô tả: ${description}.`}</span>

          {!isEmpty(ex_task_id) && (
            <Text
              style={{ cursor: "pointer" }}
              className="ml-2 text-primary"
              underline
              onClick={async () => {
                let res = await services.IOT.getProfileLegoLogDetail({
                  task_id: ex_task_id
                });
                if (res?.success && res?.data) {
                  let data = get(res, "data", {});
                  handleShowLogDetail(data);
                } else {
                  message.error(
                    get(
                      res,
                      "data.message",
                      "Không lấy được thông tin chi tiết"
                    )
                  );
                }
              }}
            >
              Chi tiết
            </Text>
          )}
        </Timeline.Item>
      );
    });
  };

  const getChecklistFilter = async () => {
    let res = await services.GdmsService.getChecklistFilter();
    if (res?.success) {
      setListFilter(res?.data || {});
    }
  };

  const getStatistic = useCallback(async device_id => {
    let res = await services.GdmsService.getStatisticDeviceById({
      device_id
    });
    const isSuccess = get(res, "success");
    if (isSuccess) {
      let data = get(res, "data") || {};
      setDataStatistic(data);
    } else {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin profile"));
    }
  }, []);

  const renderStasticInfo = dataStatistic => {
    let ma = get(dataStatistic, "ma") || 0;
    let mtbf = get(dataStatistic, "mtbf") || 0;
    let mttr = get(dataStatistic, "mttr") || 0;
    return (
      <Descriptions labelStyle={{ fontWeight: 500, minWidth: 200 }} column={3}>
        <Descriptions.Item label="MA">{ma}%</Descriptions.Item>
        <Descriptions.Item label="MTBF">{mtbf}h</Descriptions.Item>
        <Descriptions.Item label="MTTR">{mttr}h</Descriptions.Item>
      </Descriptions>
    );
  };

  useEffect(() => {
    getChecklistFilter();
  }, []);

  useEffect(() => {
    if (config?.visible && config?.dataSource) {
      let device_id = get(config?.dataSource, "device_id");
      isOver = false;
      getDetail(device_id);
      getActivity({
        page: 0,
        size: 20,
        device_id: device_id || undefined
      });
      getStatistic(device_id);
      return;
    }
  }, [config, getActivity, getDetail, getStatistic]);

  return (
    <Modal
      className="camera-monitor-modal"
      width={"80%"}
      centered
      title={`Profile thiết bị`}
      open={config?.visible}
      onCancel={() => {
        _handleToggleModal({
          visible: false,
          dataSource: {}
        });
      }}
      destroyOnClose
      footer={false}
      afterClose={() => {
        setDataDetail({});
        setDataLog({
          data: [],
          total: 0
        });
        setTimelineConfig({
          page: 0,
          size: 20
        });
        setTotalTabs({
          incident: undefined,
          task: 0
        });
      }}
    >
      <div id="general-info">
        <Row gutter={[8, 8]}>
          <Col span={20}>{renderGeneralInfo(dataDetail)}</Col>

          <Col span={4}>
            <div className="d-flex justify-content-end">
              {get(dataDetail, "asset_code") ? (
                <QRCode
                  size={64}
                  value={get(dataDetail, "asset_code", "")}
                  viewBox={`0 0 256 256`}
                />
              ) : (
                <></>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <div id="property-info">
        <div
          className="d-flex justify-content-between align-items-center mb-4"
          style={{
            fontWeight: 500,
            background: "#fafafa",
            fontSize: 16,
            padding: "6px 16px"
          }}
        >
          <span>Chất lượng thiết bị</span>
        </div>

        <Row gutter={[8, 8]}>
          <Col span={20}>{renderStasticInfo(dataStatistic)}</Col>
        </Row>
      </div>

      <div id="property-info">
        <div
          className="d-flex justify-content-between align-items-center mb-4"
          style={{
            fontWeight: 500,
            background: "#fafafa",
            fontSize: 16,
            padding: "6px 16px"
          }}
        >
          <span>Thông tin thiết bị</span>
        </div>

        {renderDetailInfo(dataDetail)}
      </div>

      <div className="mt-4 profile-timeline">
        <Tabs>
          <Tabs.TabPane tab={`Activity`} key="activity">
            <div
              style={{
                height: 350,
                overflow: "auto"
              }}
              onScroll={_handleScroll}
            >
              <Timeline
                pending={isEmpty(dataLog.data) || isOver ? false : "Loading..."}
              >
                {renderActivity(dataLog?.data || [])}
              </Timeline>
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane
            forceRender
            tab={`Incident (${
              totalTabs?.incident?.not_complete_count || 0
            } / ${totalTabs?.incident?.total || 0})`}
            key="incident"
          >
            <ProfileIncidentPage
              dataSource={config?.dataSource || {}}
              onChangeTotal={total => {
                setTotalTabs(prev => ({ ...prev, incident: total }));
              }}
            />
          </Tabs.TabPane>

          <Tabs.TabPane
            forceRender
            tab={`Task (${totalTabs?.task || 0})`}
            key="task"
          >
            <ProfileTaskPage
              listFilter={listFilter}
              dataSource={config?.dataSource || {}}
              onChangeTotal={total => {
                setTotalTabs(prev => ({ ...prev, task: total }));
              }}
            />
          </Tabs.TabPane>

          <Tabs.TabPane forceRender tab={`Log`} key="log">
            <ProfileLogPage dataSource={config?.dataSource || {}} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Modal>
  );
};
